module.exports = __webpack_public_path__ + "static/Casual-d23f0a8b290e3c4eb974e2a49ddccec2.png";